export enum LinkType {
  Filter = 'filter',
  Direct = 'direct',
  Nested = 'nested',
  HasMany = 'has-many'
}

export enum LinkResource {
  Payment = 'payment',
  Organization = 'organization',
  Bill = 'bill',
  Vendor = 'vendor',
  FundingSource = 'fundingSource',
  DeliveryMethod = 'deliveryMethod',
  PaymentRequest = 'paymentRequest',
  User = 'user',
  BusinessDirectory = 'businessDirectory',
  BusinessMatchUnlinkJobs = 'businessMatchUnlinkJobs',
  ufChargebacks = 'ufChargebacks',
  ufMelioDbCases = 'ufMelioDbCases'
}
